import { mapActions, mapState, mapGetters } from 'vuex';
import { BOTTOM_WIDGET_FOOTER_MODES } from '@/store/modules/trade';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { NAVIGATION_TABS } from '@/components/pages/page-market-detail-sushi/page-market-detail-sushi';

const MODAL_OPEN_CLASS = 'modal-open';

export default {
  props: {
    navigatedFromContractsSection: {
      type: Boolean,
      default: false,
    },
    selectedSection: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      BOTTOM_WIDGET_FOOTER_MODES,
      NAVIGATION_TABS,
      options: [
        { mode: BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH, title: 'QuickSwitch' },
        { mode: BOTTOM_WIDGET_FOOTER_MODES.PINNED, title: 'Shortcuts' },
        { mode: BOTTOM_WIDGET_FOOTER_MODES.BETSLIP, title: 'Order Slip' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', [
      'bottomWidgetFooterMode', 'previousBottomWidgetFooterMode', 'bottomWidgetFooterModeContractsSection'
    ]),
    showMarketShortcuts() {
      return this.$route.name !== 'portfolio';
    },
  },
  methods: {
    ...mapActions('trade', ['setBottomWidgetFooterMode']),
    ...mapActions('popup', ['setCurrentPopup']),
    showContractsOnlyWarning(name) {
      const contractsOnlyModes = [BOTTOM_WIDGET_FOOTER_MODES.PINNED, BOTTOM_WIDGET_FOOTER_MODES.BETSLIP];
      return this.navigatedFromContractsSection && contractsOnlyModes.includes(name);
    },
    switchTo(footerMode) {
      if (this.showContractsOnlyWarning(footerMode)) return;
      this.setBottomWidgetFooterMode(footerMode);
    },
    optionClassModifiers(option) {
      return {
        'bottom-market-links-overlay__option': true,
        'bottom-market-links-overlay__option--selected': option.mode === this.previousBottomWidgetFooterMode,
        [`bottom-market-links-overlay__option--${option.mode}`]: option.mode,
      };
    },
    closeOverlay() {
      this.switchTo(this.previousBottomWidgetFooterMode);
    },
    goToDeposit() {
      this.closeOverlay();
      this.setCurrentPopup(MODALS.ADD_FUNDS);
    },
    goToLogin() {
      this.closeOverlay();
      this.setCurrentPopup(MODALS.LOGIN);
    },
    goToSignUp() {
      this.closeOverlay();
      this.setCurrentPopup(MODALS.REGISTER);
    },
    goToDashboard() {
      this.closeOverlay();
      this.$router.push({ name: 'portfolio' });
    },
    goToMarketTab(name) {
      const el = document.querySelector(`.tabs__link-name-${name}`);
      if (el !== null) {
        this.closeOverlay();
        el.click();
      }
    },
  },
  created() {
    document.documentElement.classList.add(MODAL_OPEN_CLASS);
    document.body.classList.add(MODAL_OPEN_CLASS);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
    document.body.classList.remove(MODAL_OPEN_CLASS);
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/bottom-market-links-overlay/bottom-market-links-overlay.js